import React from 'react';
import { Award, Shield, TrendingUp, Users } from 'lucide-react';

const SocialProofSection = () => {
  const caratteristiche = [
    {
      icona: Award,
      numero: "Agenzia",
      descrizione: "Assimoco accreditata Eticapro"
    },
    {
      icona: Shield,
      numero: "Specialisti",
      descrizione: "Terzo Settore e Cooperative"
    },
    {
      icona: Users,
      numero: "Cooperativa",
      descrizione: "Valori mutualistici condivisi"
    },
    {
      icona: TrendingUp,
      numero: "Crescita",
      descrizione: "Al servizio della comunità"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-[#1B2380]/10 text-[#1B2380] rounded-full text-sm font-semibold mb-4">
            La Nostra Forza
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1B2380] mb-6">
            Fiducia, competenza e{' '}
            <span className="text-[#0E8C84]">vicinanza al territorio</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La nostra esperienza nel mondo cooperativo e del Terzo Settore ci permette 
            di comprendere a fondo le vostre esigenze e offrire soluzioni davvero efficaci.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {caratteristiche.map((item, index) => {
            const IconComponent = item.icona;
            return (
              <div
                key={index}
                className="group text-center animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-20 h-20 bg-gradient-to-br from-[#1B2380] to-[#0E8C84] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg">
                  <IconComponent className="text-white" size={36} />
                </div>
                <div className="text-3xl font-bold text-[#1B2380] mb-2">
                  {item.numero}
                </div>
                <p className="text-gray-600 font-medium">
                  {item.descrizione}
                </p>
              </div>
            );
          })}
        </div>

        {/* Value Propositions */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <h3 className="text-xl font-bold text-[#1B2380] mb-4">
              Specializzazione nel Terzo Settore
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Conosciamo le sfide specifiche di cooperative, associazioni e fondazioni. 
              La nostra consulenza è mirata e competente.
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <h3 className="text-xl font-bold text-[#1B2380] mb-4">
              Approccio Consulenziale
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Non vendiamo polizze, costruiamo partnership. Ascoltiamo, analizziamo, 
              proponiamo soluzioni su misura.
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <h3 className="text-xl font-bold text-[#1B2380] mb-4">
              Vicinanza ai Territori
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Siamo presenti e operativi sul territorio. Quando ci contatti, parli 
              con professionisti che conoscono la tua realtà.
            </p>
          </div>
        </div>

        {/* Trust Badge */}
        <div className="bg-gradient-to-r from-[#1B2380] to-[#0E8C84] rounded-2xl p-8 sm:p-12 text-center shadow-xl animate-fade-in-up">
          <div className="max-w-3xl mx-auto">
            <Shield className="text-white mx-auto mb-6" size={48} />
            <h3 className="text-3xl font-bold text-white mb-4">
              La solidità di Assimoco, i valori della cooperazione
            </h3>
            <p className="text-xl text-white/90 mb-8">
              Agenzia Assimoco accreditata Eticapro, operiamo con 
              la trasparenza e l'etica che caratterizzano il movimento cooperativo.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-lg border border-white/30">
                <span className="text-white font-semibold">Cooperativa di Servizi Assicurativi</span>
              </div>
              <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-lg border border-white/30">
                <span className="text-white font-semibold">Società Cooperativa</span>
              </div>
              <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-lg border border-white/30">
                <span className="text-white font-semibold">Società Benefit Certificata</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
